export function formatIncludeRented(includeRented: string | string[]) {
    if (includeRented === 'true') {
        return 'Include rented';
    }

    return '';
}
